import { Component, OnInit } from '@angular/core';
import { PageTrackingService } from './core/page-tracking';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'lic-project';

  constructor(private readonly pageTrackingService: PageTrackingService) { }

  ngOnInit(): void {
    // Start capturing route changes once per app bootstrap.
    // The service is a no-op when environment.pageTracking.enabled is false.
    this.pageTrackingService.startTracking();
  }
}
